import type { ReactNode } from 'react';

export const symbol_nest_cam_iq: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-80q-25 0-42.5-17.5T280-140h170v-181q-107-14-178.5-93T200-600q0-117 81.5-198.5T480-880q117 0 198.5 81.5T760-600q0 107-71.5 186T510-321v181h170q0 25-17.5 42.5T620-80H340Zm296-364q64-64 64-156t-64-156q-64-64-156-64t-156 64q-64 64-64 156t64 156q64 64 156 64t156-64Zm-227-85q-29-29-29-71t29-71q29-29 71-29t71 29q29 29 29 71t-29 71q-29 29-71 29t-71-29Z"
		/>
	</svg>
);
